import React, { useState, useEffect, useRef, useCallback } from 'react';

import LinkifiedText from '../../shared/LinkifiedText/LinkifiedText';
import ReadMoreButton from '../buttons/ReadMoreButton/ReadMoreButton';

import './FadeSlider.css';

const FadeSlider = ({ slides, interval = 6000 }) => {
  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    if (isPaused) return;
    if (timerRef.current) clearInterval(timerRef.current);
    if (slides.length > 1) {
      timerRef.current = setInterval(() => {
        setPrevIndex(index);
        setIndex((prev) => (prev + 1) % slides.length);
      }, interval);
    }
  }, [slides.length, interval, index, isPaused]);

  const stopTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  useEffect(() => {
    startTimer();
    return () => stopTimer();
  }, [startTimer]);

  const handleMouseEnter = () => {
    stopTimer();
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
    startTimer();
  };

  return (
    <div
      className='fade-slider-container'
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className='fade-slider-overlay' />
      {slides.length &&
        slides.map((slide, i) => {
          const isActive = i === index;
          const isPrev = i === prevIndex;

          return (
            <div
              key={i}
              className={`fade-slider-slide-container ${
                isActive ? 'active' : isPrev ? 'prev' : ''
              }`}
            >
              <div
                style={{
                  backgroundImage: `url(${slide.homeImageUrl || slide.imageUrl})`,
                }}
                className={`fade-slider-slide-img ${
                  isActive ? 'active' : isPrev ? 'prev' : ''
                }`}
              />
              <div className='fade-slider-overlay-container'>
                <div
                  className={`fade-slider-overlay-content-container ${
                    isActive ? 'active' : isPrev ? 'prev' : ''
                  }`}
                >
                  <h2>{slide.homeTitle || slide.title}</h2>
                  <p>
                    <LinkifiedText className='admin-card-field-link'>
                      {slide.homeExcerpt || slide.excerpt}
                    </LinkifiedText>
                  </p>
                  <ReadMoreButton to={`/blog/${slide.slug}`} />
                </div>
              </div>
            </div>
          );
        })}

      {slides.length > 1 && (
        <div className='fade-slider-pagination-container'>
          <div className='fade-slider-pagination'>
            {slides.map((_, btnIndex) => (
              <button
                key={btnIndex}
                className={`fade-slider-page-btn ${
                  btnIndex === index ? 'active' : ''
                }`}
                onClick={() => {
                  setPrevIndex(index);
                  setIndex(btnIndex);
                  stopTimer();
                  setIsPaused(true);
                }}
              >
                {btnIndex + 1}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FadeSlider;
